<template>
  <div class="content1">
    <el-form ref="ruleForm" :model="form" :rules="rules" label-width="160px">
      <div class="box">
        <div class="title">
          基本信息
        </div>
        <el-form-item label="活动名称" class="fixedWidth" prop="name">
          <el-input v-model="form.name" size="mini"></el-input>
        </el-form-item>
        <el-form-item label="活动时间">
          <div>
            <!-- <el-date-picker
              v-model="activityData"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              size="small"
              value-format="yyyy-MM-dd HH:mm:ss"
              @change="dateMethods"
            >
            </el-date-picker> -->
            <el-date-picker
              v-model="dateValue[0]"
              type="date"
              class="inputWidth"
              placeholder="开始日期"
              value-format="yyyy-MM-dd"
              size="small"
            ></el-date-picker>
            <el-time-picker
              placeholder="时间"
              v-model="timeValue[0]"
              class="inputWidth"
              format="HH:mm"
              value-format="HH:mm"
              arrow-control
              size="small"
            ></el-time-picker>

            <span class="inputMargin">至</span>
            <el-date-picker
              v-model="dateValue[1]"
              type="date"
              class="inputWidth"
              placeholder="结束日期"
              value-format="yyyy-MM-dd"
              size="small"
            ></el-date-picker>
            <el-time-picker
              placeholder="时间"
              v-model="timeValue[1]"
              class="inputWidth"
              format="HH:mm"
              value-format="HH:mm"
              arrow-control
              size="small"
            ></el-time-picker>
            <!-- <div class="color">
              活动到期后将自动失效，失效后不可延长
            </div> -->
          </div>
        </el-form-item>
        <el-form-item label="参与门店">
          <el-radio-group v-model="form.room_status">
            <el-radio label="0">全部门店</el-radio>
            <el-radio label="1">
              部分门店
              <el-select
                multiple
                size="small"
                v-model="roomIdS"
                placeholder="请选择"
                class="newInputWidth inputMargin"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="item in store_options"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-radio>
          </el-radio-group>
        </el-form-item>
      </div>
      <div class="box">
        <div class="title">
          参与规则
        </div>
        <el-form-item label="参与消费">
          <el-radio-group v-model="form.use_status">
            <el-radio label="0">每次消费</el-radio>
            <el-radio label="1">仅首次消费</el-radio>
            <el-radio label="2">第二次及之后的消费</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- <el-form-item label="参与业务">
          <el-radio-group v-model="form.bus_status">
            <el-radio label="0">油品</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item label="油品选择" prop="checkedRefule">
          <multipleChoice
            :jude="3"
            :editDatas="checkedRefule"
            @checkedGoods="checkedGoods(0, $event)"
          ></multipleChoice>
        </el-form-item>
      </div>
      <div class="box">
        <div class="title">
          基础赠送规则
        </div>
        <el-form-item label="赠送规则">
          <el-radio-group
            v-model="form.give_status"
            :disabled="initStatus"
            @change="reulesChange"
          >
            <el-radio label="1">每满赠送</el-radio>
            <el-radio label="0">单次每满赠送</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 单次每满赠送 -->
        <el-form-item
          v-for="(item, index) in onceRule"
          :key="index + 11"
          :label="'规则' + changeH(index)"
          v-show="form.give_status == 0"
        >
          <!-- new -->
          <div class="table">
            <div class="table-left">
              <div class="name">赠送条件</div>
              <div class="flex">
                <el-form-item
                  label="满"
                  label-width="40px"
                  style="margin-bottom: 0px; margin-right: 5px"
                >
                  <el-input
                    size="small"
                    v-model="item.enough_money"
                    type="number"
                    @blur="
                      item.enough_money = Number(item.enough_money).toFixed(2)
                    "
                  ></el-input>
                </el-form-item>
                <!-- <div class="">
                  满
                </div>
                <div class="newInputWidth flex inputMargin">
                  <el-input size="small" v-model="item.enough_money"></el-input>
                </div> -->
                <div>元</div>
              </div>
              <div class="color">
                注明：当定义多个规则时，系统优先适用所满足的最高条件
              </div>
            </div>
            <div class="table-right">
              <div class="flex" style=" justify-content:space-between;">
                <div class="name">赠送内容</div>
                <el-button type="text" @click="delRule(index)">删除</el-button>
              </div>
              <div class="flex marginBottom fontSize14">
                <el-checkbox
                  v-model="item.moneyStatus"
                  @change="$forceUpdate()"
                >
                </el-checkbox>
                <div class="inputMargin width30">
                  送
                </div>
                <div class="newInputWidth inputMargin flex">
                  <el-input
                    size="small"
                    v-model="item.money"
                    :disabled="item.moneyStatus ? false : true"
                    type="number"
                    @blur="item.money = Number(item.money).toFixed(2)"
                  ></el-input>
                </div>
                <div>元余额</div>
              </div>
              <div class="flex marginBottom fontSize14">
                <el-checkbox
                  v-model="item.pointStatus"
                  @change="$forceUpdate()"
                >
                </el-checkbox>
                <div class="inputMargin width30">
                  送
                </div>
                <div class="newInputWidth inputMargin">
                  <el-input
                    size="small"
                    v-model="item.point"
                    :disabled="item.pointStatus ? false : true"
                    type="number"
                    @blur="item.point = Number(item.point).toFixed(2)"
                  ></el-input>
                </div>
                <div>积分</div>
              </div>
              <div class="fontSize14 marginBottom" style="display:flex">
                <el-checkbox
                  v-model="item.couponStatus"
                  @change="$forceUpdate()"
                >
                </el-checkbox>
                <div class="inputMargin width30">
                  送券
                </div>
                <div class="inputMargin ">
                  <el-button
                    size="small"
                    plain
                    icon="el-icon-plus"
                    :disabled="item.couponStatus ? false : true"
                    @click="selectCoupon(index)"
                    >选择券</el-button
                  >
                  <div style="display:flex;flex-wrap: wrap; margin-top: 10px;">
                    <!-- <el-tag
                      v-for="(tag, idx) in item.sList"
                      :key="tag.id + 1"
                      closable
                      @close="delTagItem(index, idx)"
                      style="margin-bottom:5px;margin-right:5px;"
                    >
                      {{ tag.name }}
                    </el-tag> -->
                    <el-tag
                      v-for="(tag, index) in item.sList"
                      :key="index"
                      style="margin-bottom:5px;margin-right:5px;"
                    >
                      {{ tag.name }}
                      <span v-if="tag.choseNum != 1">
                        <span class="colorRed">×</span>
                        {{ tag.choseNum }} 张</span
                      >
                    </el-tag>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-form-item>
        <!-- 每满赠送 -->
        <el-form-item
          v-for="(everyitem, everyIndex) in everyRule"
          :key="everyIndex + 2"
          :label="'规则' + changeH(everyIndex)"
          v-show="form.give_status == 1"
        >
          <!-- new -->
          <!-- :prop="'everyRule.' + index + '.enough_money'"
                  :rules="{
                    required: true,
                    message: '请填写赠送条件',
                    trigger: 'blur'
                  }" -->
          <div class="table">
            <div class="table-left">
              <div class="name">赠送条件</div>
              <div class="flex">
                <el-form-item
                  label="每满"
                  label-width="60px"
                  style="margin-bottom: 0px; margin-right: 5px"
                >
                  <el-input
                    size="small"
                    v-model="everyitem.enough_money"
                    type="number"
                    @blur="
                      everyitem.enough_money = Number(
                        everyitem.enough_money
                      ).toFixed(2)
                    "
                  ></el-input>
                </el-form-item>
                <div>元</div>
              </div>
              <div class="color">
                注明：当满足条件时，以最终订单支付金额为准，每满赠送。
                如：支付200元，条件为每满100元时，系统默认赠送两次
              </div>
            </div>
            <div class="table-right">
              <div class="flex" style=" justify-content:space-between;">
                <div class="name">赠送内容</div>
                <el-button type="text" @click="delRule(everyIndex)"
                  >删除</el-button
                >
              </div>
              <div class="flex marginBottom fontSize14">
                <el-checkbox v-model="everyitem.moneyStatus"> </el-checkbox>
                <div class="inputMargin width30">
                  送
                </div>
                <div class="newInputWidth inputMargin flex">
                  <el-input
                    size="small"
                    v-model="everyitem.money"
                    :disabled="everyitem.moneyStatus ? false : true"
                    type="number"
                    @blur="everyitem.money = Number(everyitem.money).toFixed(2)"
                  ></el-input>
                </div>
                <div>元余额，最多奖励</div>
                <div class="newInputWidth inputMargin flex">
                  <el-input
                    size="small"
                    v-model="everyitem.money_limit"
                    :disabled="everyitem.moneyStatus ? false : true"
                    type="number"
                    @blur="
                      everyitem.money_limit = Number(
                        everyitem.money_limit
                      ).toFixed(2)
                    "
                  ></el-input>
                </div>
                <div>元余额</div>
              </div>
              <div class="flex marginBottom fontSize14">
                <el-checkbox v-model="everyitem.pointStatus"> </el-checkbox>
                <div class="inputMargin width30">
                  送
                </div>
                <div class="newInputWidth inputMargin">
                  <el-input
                    size="small"
                    v-model="everyitem.point"
                    :disabled="everyitem.pointStatus ? false : true"
                    type="number"
                    @blur="everyitem.point = Number(everyitem.point).toFixed(2)"
                  ></el-input>
                </div>
                <div>积分，最多赠送</div>
                <div class="newInputWidth inputMargin flex">
                  <el-input
                    size="small"
                    v-model="everyitem.point_limit"
                    :disabled="everyitem.pointStatus ? false : true"
                    type="number"
                    @blur="
                      everyitem.point_limit = Number(
                        everyitem.point_limit
                      ).toFixed(2)
                    "
                  ></el-input>
                </div>
                <div>积分</div>
              </div>
              <div class="fontSize14 marginBottom" style="display:flex">
                <el-checkbox
                  v-model="everyitem.couponStatus"
                  @change="$forceUpdate()"
                >
                </el-checkbox>
                <div class="inputMargin width30">
                  送券
                </div>
                <div class="inputMargin ">
                  <el-button
                    size="small"
                    plain
                    icon="el-icon-plus"
                    :disabled="everyitem.couponStatus ? false : true"
                    @click="selectCoupon(everyIndex)"
                    >选择券</el-button
                  >
                  <div style="display:flex;flex-wrap: wrap; margin-top: 10px;">
                    <!-- <el-tag
                      v-for="(everyTag, everyidx) in everyitem.sList"
                      :key="everyTag.id + 1"
                      closable
                      @close="delTagItem(everyIndex, everyidx)"
                      style="margin-bottom:5px;margin-right:5px;"
                    >
                      {{ everyTag.name }}
                    </el-tag> -->
                    <el-tag
                      v-for="(tag, index) in everyitem.sList"
                      :key="index"
                      style="margin-bottom:5px;margin-right:5px;"
                    >
                      {{ tag.name }}
                      <span v-if="tag.choseNum != 1">
                        <span class="colorRed">×</span>
                        {{ tag.choseNum }} 张</span
                      >
                    </el-tag>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="table">
            <div class="table-left">
              <div class="name">赠送条件</div>
              <div class="flex">
                <el-form-item
                  label="每满"
                  label-width="60px"
                  :prop="'rule.' + 0 + '.enough_money'"
                  :rules="{
                    required: true,
                    message: '请填写赠送条件',
                    trigger: 'blur'
                  }"
                  style="margin-bottom: 0px; margin-right: 5px"
                >
                  <el-input
                    size="small"
                    v-model="form.rule[0].enough_money"
                    type="number"
                    @blur="
                      form.rule[0].enough_money = Number(
                        form.rule[0].enough_money
                      ).toFixed(2)
                    "
                  ></el-input>
                </el-form-item>
                <div>元</div>
              </div>
            </div>
            <div class="table-right">
              <div class="flex" style=" justify-content:space-between;">
                <div class="name">赠送内容</div>
              </div>
              <div class="flex marginBottom fontSize14">
                <el-checkbox v-model="form.rule[0].moneyStatus"> </el-checkbox>
                <div class="inputMargin width30">
                  送
                </div>
                <div class="newInputWidth inputMargin flex">
                  <el-input
                    size="small"
                    v-model="form.rule[0].money"
                    :disabled="form.rule[0].moneyStatus ? false : true"
                    type="number"
                    @blur="
                      form.rule[0].money = Number(form.rule[0].money).toFixed(2)
                    "
                  ></el-input>
                </div>
                <div>元余额，最多奖励</div>
                <div class="newInputWidth inputMargin flex">
                  <el-input
                    size="small"
                    v-model="form.rule[0].money_limit"
                    :disabled="form.rule[0].moneyStatus ? false : true"
                    type="number"
                    @blur="
                      form.rule[0].money_limit = Number(
                        form.rule[0].money_limit
                      ).toFixed(2)
                    "
                  ></el-input>
                </div>
                <div>元余额</div>
              </div>
              <div class="flex marginBottom fontSize14">
                <el-checkbox v-model="form.rule[0].pointStatus"> </el-checkbox>
                <div class="inputMargin width30">
                  送
                </div>
                <div class="newInputWidth inputMargin">
                  <el-input
                    size="small"
                    v-model="form.rule[0].point"
                    :disabled="form.rule[0].pointStatus ? false : true"
                    type="number"
                    @blur="
                      form.rule[0].point = Number(form.rule[0].point).toFixed(2)
                    "
                  ></el-input>
                </div>
                <div>积分，最多赠送</div>
                <div class="newInputWidth inputMargin flex">
                  <el-input
                    size="small"
                    v-model="form.rule[0].point_limit"
                    :disabled="form.rule[0].pointStatus ? false : true"
                    type="number"
                    @blur="
                      form.rule[0].point_limit = Number(
                        form.rule[0].point_limit
                      ).toFixed(2)
                    "
                  ></el-input>
                </div>
                <div>积分</div>
              </div>
              <div class="fontSize14 marginBottom" style="display:flex">
                <el-checkbox
                  v-model="form.rule[0].couponStatus"
                  @change="$forceUpdate()"
                >
                </el-checkbox>
                <div class="inputMargin width30">
                  送券
                </div>
                <div class="inputMargin ">
                  <el-button
                    size="small"
                    plain
                    icon="el-icon-plus"
                    :disabled="form.rule[0].couponStatus ? false : true"
                    @click="selectCoupon(index)"
                    >选择券</el-button
                  >
                  <div style="display:flex;flex-wrap: wrap; margin-top: 10px;">
                    <el-tag
                      v-for="(tag, idx) in form.rule[0].sList"
                      :key="tag.id"
                      closable
                      @close="delTagItem(index, idx)"
                      style="margin-bottom:5px;margin-right:5px;"
                    >
                      {{ tag.name }}
                    </el-tag>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
        </el-form-item>
        <el-form-item>
          <div class="flex">
            <el-button size="small" plain icon="el-icon-plus" @click="addRule"
              >添加规则</el-button
            >
            <div class="color">
              注：最多添加十个规则
            </div>
          </div>
        </el-form-item>
        <el-form-item label="会员卡等级选择">
          <multipleChoice
            :alone="1"
            :editDatas="checkedVip"
            :Datas="vipData"
            @checkedGoods="checkedGoods(1, $event)"
            ref="vipChild"
          ></multipleChoice>
        </el-form-item>
        <el-form-item label="适用人群">
          <el-radio-group v-model="form.take_status" @change="objChange">
            <el-radio label="0">所有人群</el-radio>
            <el-radio label="1">指定标签</el-radio>
          </el-radio-group>
        </el-form-item>
        <!--  v-show="form.take_status == '3'" -->
        <el-form-item label="标签选择" v-show="form.take_status == '1'">
          <multipleChoice
            :alone="1"
            :editDatas="selectSign"
            :Datas="signList"
            @checkedGoods="checkedGoods(4, $event)"
            ref="signChild"
          ></multipleChoice>
        </el-form-item>
        <el-form-item label="支付方式选择">
          <el-checkbox-group v-model="selectPay" @change="changePay">
            <el-checkbox
              v-for="item in payList"
              :key="item.value"
              :label="item.value"
              >{{ item.title }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>
        <el-form-item v-if="payStatus">
          <el-checkbox-group v-model="branchPay" @change="changeBranchPay">
            <el-checkbox label="balance">会员卡</el-checkbox>
            <el-checkbox label="card_balance">加油卡</el-checkbox>
            <el-checkbox label="team_balance">车队卡</el-checkbox>
          </el-checkbox-group>
          <div class="selection_box" v-if="branchOil">
            <el-checkbox-group v-model="selectOilsCard">
              <el-checkbox
                v-for="item in oilsCardList"
                :key="item.id"
                :label="item.id"
                >{{ item.name }}</el-checkbox
              >
            </el-checkbox-group>
          </div>
          <div class="selection_box" v-if="branchCard">
            <el-checkbox-group v-model="selectCardList">
              <el-checkbox
                v-for="item in cardListCard"
                :key="item.id"
                :label="item.id"
                >{{ item.name }}</el-checkbox
              >
            </el-checkbox-group>
          </div>
        </el-form-item>
        <el-form-item label="每人每日参与次数">
          <el-radio-group
            v-model="form.day_status"
            class="flex"
            style="height: 40px"
          >
            <el-radio label="0">无上限</el-radio>
            <el-radio label="1" class="flex">
              <div class="flex">
                限
                <div class="newInputWidth inputMargin">
                  <el-input
                    size="small"
                    v-model="form.limit_num"
                    type="number"
                    min="0"
                    @blur="form.limit_num = Number(form.limit_num).toFixed(2)"
                  ></el-input>
                </div>
                次
              </div>
            </el-radio>
          </el-radio-group>
        </el-form-item>
      </div>
      <!-- <div class="box">
        <div class="title">
          积分翻倍赠送规则
        </div>
        <el-form-item label="翻倍规则">
          <div class="marginBottom10">
            <el-radio label="0">不翻倍，按基础赠送规则赠送</el-radio>
          </div>
          <div class="flex marginBottom10">
            <el-radio label="1" class="flex">
              <div class="flex">
                顾客生日当天赠送
                <div class="newInputWidth inputMargin">
                  <el-input size="small"></el-input>
                </div>
                积分
              </div>
            </el-radio>
          </div>
          <div class="flex marginBottom10">
            <el-radio label="1" class="flex">
              <div class="flex">
                每周：
                <el-select
                  size="small"
                  v-model="value"
                  placeholder="请选择"
                  class="newInputWidth inputMargin"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <div class="inputMargin">赠送</div>
                <div class="newInputWidth inputMargin">
                  <el-input size="small"></el-input>
                </div>
                倍积分
              </div>
            </el-radio>
          </div>
          <div class="flex marginBottom10">
            <el-radio label="1" class="flex">
              <div class="flex">
                每月：
                <el-select
                  size="small"
                  v-model="value"
                  placeholder="请选择"
                  class="newInputWidth inputMargin"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <div class="inputMargin">日</div>
                <div class="inputMargin">赠送</div>
                <div class="newInputWidth inputMargin">
                  <el-input size="small"></el-input>
                </div>
                倍积分
              </div>
            </el-radio>
          </div>
          <div class="flex marginBottom10">
            <el-radio label="1" class="flex">
              <div class="flex">
                每年：
                <el-select
                  size="small"
                  v-model="value"
                  placeholder="请选择"
                  class="newInputWidth inputMargin"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <div class="inputMargin">月</div>
                <el-select
                  size="small"
                  v-model="value"
                  placeholder="请选择"
                  class="newInputWidth inputMargin"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <div class="inputMargin">日</div>
                <div class="inputMargin">赠送</div>
                <div class="newInputWidth inputMargin">
                  <el-input size="small"></el-input>
                </div>
                倍积分
              </div>
            </el-radio>
          </div>
          <div class="color">注：最终赠送积分=基础赠送积分*倍数</div>
        </el-form-item>
      </div> -->
    </el-form>
    <!-- 底部提交 -->
    <div class="bottom">
      <el-button @click="$router.go(-1)">取消</el-button>
      <el-button type="primary" @click="submit('ruleForm')">确定</el-button>
    </div>
    <!-- 优惠券弹窗 -->
    <el-dialog :visible.sync="showSelecter" @close="showSelecter = false">
      <newSelectCommodityNum
        @close="showSelecter = false"
        @getCommod="getCommod"
        :sList="sList"
        :jude="2"
      ></newSelectCommodityNum>
    </el-dialog>
  </div>
</template>
<script>
// import selectCommodity from "@/components/commodity/selectCommodity.vue";
import newSelectCommodityNum from "@/components/commodity/newSelectCommodityNum.vue";
import multipleChoice from "@/components/commodity/multipleChoice.vue";
import { mapGetters } from "vuex";
import { storeSelect } from "@/api/employee";
import { listRefule, vipList } from "@/api/vip";
import { cardList } from "@/api/motorcade";
import { addConsumption, allTag, detailConsumption, editConsumption } from "@/api/market";

export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  components: {
    multipleChoice,
    newSelectCommodityNum
  },
  data() {
    return {
      // new 卡项
      payStatus: false, //当选中余额支付时会出现多种情形
      branchOil: false, //加油卡余额支付
      branchCard: false, //车队卡余额支付
      branchPay: [],
      //
      payList: [
        {
          value: "normal_allinpay", //多种情形，合并下级分支
          title: "聚合支付"
        },
        {
          value: "lakala", //多种情形，合并下级分支
          title: "快捷支付"
        },
        {
          value: "leshua", //多种情形，合并下级分支
          title: "乐付"
        },
        {
          value: "branch", //多种情形，合并下级分支
          title: "余额支付"
        },
        {
          value: "cash",
          title: "现金支付"
        },
        {
          value: "unionpay",
          title: "银联支付"
        },
        {
          value: "wxpay",
          title: "微信支付"
        },
        {
          value: "alipay",
          title: "支付宝支付"
        },
        {
          value: "allinpay",
          title: "通联支付"
        },
        {
          value: "fuiou",
          title: "富友支付"
        }
      ],
      selectPay: [], //支付方式
      card_type: 0,
      oilsCardList: [], //加油卡列表
      selectOilsCard: [], //加油卡列表
      signList: [], //标签列表
      selectSign: [],
      cardListCard: [], //车队卡列表
      selectCardList: [], //车队卡列表
      //
      initStatus: false,
      checkedRefule: [], // 更改选择部分商品的样式

      jude: this.$route.query.status,
      //会员等级
      checkedVip: [],
      vipData: [],
      activityData: [],
      dateValue: ["", ""], //活动时间
      timeValue: ["", ""],
      store_options: [], //门店列表
      roomIdS: [],
      // 优惠券数据
      showSelecter: false, //优惠券选择器
      selected: [], //选择的优惠券
      sList: [], //已选择的优惠券列表
      sIndex: 0, //选择优惠券的档位index
      // end
      imageUrl: "",
      setServel: "0",
      checkList: ["0", "1"],
      manualShow: false,
      form: {
        // 新增
        payment_code: "", //支付方式
        type_card_id: "", //油卡类型
        team_card_id: "", //车队卡类型
        // end
        checkedRefule: "",
        name: "",
        start_time: "", //活动开始时间
        end_time: "",
        room_status: "0", //参与状态0：全部门店1：部分门店
        room_ids: "", //门店
        use_status: "0", //参与消费规则0：每次消费1:首次消费2:二次及以后消费
        bus_status: "0", //参与业务0:油品1:类别
        goods_ids: "", //
        cate_ids: "", //
        give_status: "1", //给予规则0:单次每满赠1:每满赠
        rule: [
          {
            enough_money: "", //
            money_status: "0", //
            money: "", //
            money_limit: "", //
            point_status: "0", //
            point: "", //
            point_limit: "", //
            coupon_status: "0", //
            coupon_ids: "", //
            sList: [],
            //
            moneyStatus: false,
            pointStatus: false,
            couponStatus: false
          }
        ], // 单次每满赠送

        take_status: "0", //参与对象0:不限1:全部会员2:全部用户3：按会员等级4：按用户标准
        level_card_status: "1", //设置会员卡等级0：全部1：部分等级
        level_card_id: "", //会员等级
        user_tag_id: "", //用户标签
        tags_ids: "", //标签组ids
        day_status: "0", //每人每日参与次数0:无上限1:限制
        limit_num: ""
      },
      everyRule: [
        {
          enough_money: "", //
          money_status: "0", //
          money: "", //
          money_limit: "", //
          point_status: "0", //
          point: "", //
          point_limit: "", //
          coupon_status: "0", //
          coupon_ids: "", //
          sList: [],
          //
          moneyStatus: false,
          pointStatus: false,
          couponStatus: false
        }
      ],
      onceRule: [
        {
          enough_money: "", //
          money_status: "0", //
          money: "", //
          money_limit: "", //
          point_status: "0", //
          point: "", //
          point_limit: "", //
          coupon_status: "0", //
          coupon_ids: "", //
          sList: [],
          //
          moneyStatus: false,
          pointStatus: false,
          couponStatus: false
        }
      ],
      rules: {
        name: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          { min: 1, max: 10, message: "长度在 1 到 10 个字符", trigger: "blur" }
        ]
      },
      // 规则一，活动层级
      // form.give_status: "0",
      // 数字转成汉字
      tranformHanzi: {}
    };
  },
  beforeMount() {
    this.initStoreType();
    this.initVip();
    if (this.$route.query.status != 0) {
      this.initStatus = true;
      console.log("我走这一步", this.$route.query.status);
      this.details();
    }
  },
  methods: {
    // 支付方式
    changePay(val) {
      console.log(val);
      this.payStatus = val.some(item => {
        return item == "branch";
      });
      console.log("支付方式是否有余额", this.payStatus);
    },
    // 余额方式更改
    changeBranchPay(val) {
      console.log(val);
      this.branchOil = val.some(item => {
        return item == "card_balance";
      });
      this.branchCard = val.some(item => {
        return item == "team_balance";
      });
    },
    reulesChange(type) {
      // if (type == 1) {
      //   console.log("reulesChange", type);
      // }
    },
    // 日期組件
    dateMethods(val) {
      console.log("变更日期i", val);
    },
    // 提交
    submit(formitem) {
      console.log("提交之前的数据", this.form);
      // return;
      this.$refs[formitem].validate(valid => {
        if (valid) {
          delete this.form.create_time;
          delete this.form.delete_time;
          //活动时间
          // this.activityData
          // if (this.activityData.length == 0) {
          //   this.$message.warning("请填写活动时间！！");
          //   return;
          // }
          if (!this.dateValue[0]) {
            this.$message("未选择开始时间");
            return;
          } else if (!this.dateValue[1]) {
            this.$message("未选择结束时间");
            return;
          } else if (
            new Date(this.dateValue[0]).getTime() >
            new Date(this.dateValue[1]).getTime()
          ) {
            this.$message("开始时间不能大于结束时间");
            return;
          } else {
            this.form.start_time = this.timeValue[0]
              ? this.dateValue[0] + " " + this.timeValue[0]
              : this.dateValue[0] + " 00:00:00";
            this.form.end_time = this.timeValue[1]
              ? this.dateValue[1] + " " + this.timeValue[1]
              : this.dateValue[1] + " 23:59:59";
            this.form.start_time =
              new Date(this.form.start_time).getTime() / 1000;
            this.form.end_time = new Date(this.form.end_time).getTime() / 1000;
          }
          if (this.form.checkedRefule.length == 0) {
            this.$message.warning("请选择油品！！");
            return;
          }
          if (this.checkedVip.length == 0) {
            this.$message.warning("请选择会员卡等级！！");
            return;
          }
          // 新增
          // 适用人群 0 全部 1 会员标签
          if (this.form.take_status == 1 && this.selectSign.length == 0) {
            this.$message.warning("请至少选择一种会员标签！！");
            return;
          } else {
            this.form.tags_ids = this.selectSign.join(",");
          }
          if (this.selectPay.length == 0) {
            this.$message.warning("请至少选择一种支付方式！！");
            return;
          }
          if (this.payStatus) {
            // 加油卡
            if (this.branchOil && this.selectOilsCard.length == 0) {
              this.$message.warning("请至少选择一种加油卡项！！");
              return;
            } else {
              // 整合油卡类型
              this.form.type_card_id = this.selectOilsCard.join(",");
            }
            // 车队卡
            if (this.branchCard && this.selectCardList.length == 0) {
              this.$message.warning("请至少选择一种车队卡项！！");
              return;
            } else {
              // 整合车队卡类型
              this.form.team_card_id = this.selectCardList.join(",");
            }
          }
          // 整合支付方式
          // 去重
          for (let i = 0; i < this.selectPay.length; i++) {
            for (let j = i + 1; j < this.selectPay.length; j++) {
              if (
                this.selectPay[i] == this.selectPay[j] ||
                this.selectPay[j] == "balance"
              ) {
                this.selectPay.splice(j, 1);
                j--;
              }
            }
          }

          let newPayShell = this.selectPay;
          let newAllPayShell = [];
          newPayShell.map(item => {
            if (item != "branch") {
              newAllPayShell.push(item);
            }
          });
          // 余额选项去重
          for (let i = 0; i < this.branchPay.length; i++) {
            for (let j = i + 1; j < this.branchPay.length; j++) {
              if (this.branchPay[i] == this.branchPay[j]) {
                this.branchPay.splice(j, 1);
                j--;
              }
            }
          }
          console.log("newAllPayShell", newAllPayShell);
          console.log("branchPay", this.branchPay);
          this.form.payment_code = this.payStatus
            ? newAllPayShell.concat(this.branchPay).join(",")
            : newAllPayShell.join(",");
          // return;
          // end
          // 部分门店
          console.log("roomIdS", this.roomIdS);
          if (this.form.room_status == "1") {
            if (this.roomIdS.length > 0) {
              this.form.room_ids = this.roomIdS.join(",");
              console.log("11部分门店", this.form.room_ids);
            } else {
              this.$message.warning("请选择部分门店");
              return;
            }
          }

          //规则

          if (this.form.give_status == "0") {
            let rules = this.onceRule;
            rules.forEach(item => {
              item.money_status = item.moneyStatus ? 1 : 0;
              item.point_status = item.pointStatus ? 1 : 0;
              item.coupon_status = item.couponStatus ? 1 : 0;
            });
            this.form.rule = rules;
          } else if (this.form.give_status == "1") {
            let rules = this.everyRule;
            rules.forEach(item => {
              item.money_status = item.moneyStatus ? 1 : 0;
              item.point_status = item.pointStatus ? 1 : 0;
              item.coupon_status = item.couponStatus ? 1 : 0;
            });
            this.form.rule = rules;
          }
          // 归0
          if (this.form.day_status == "0") {
            this.form.limit_num = "";
          }
          console.log("提交之前的数据", this.form);
          let data = { ...this.form };
          data.app_id = this.app_id;
          data.token = this.token;
          if (this.jude == 0) {
            addConsumption(data).then(res => {
              if (res.code == 200) {
                this.$message.success("保存成功");
                this.$router.go(-1);
              } else {
                this.$message.warning(res.msg);
              }
              console.log("保存", res);
            });
          } else {
            editConsumption(data).then(res => {
              if (res.code == 200) {
                this.$message.success("编辑成功");
                this.$router.go(-1);
              } else {
                this.$message.warning(res.msg);
              }
              console.log("保存", res);
              console.log("编辑", res);
            });
          }
          console.log("tijiao", data);
        } else {
          this.$message.warning("您还有必填项没有填写！！");
          console.log("error submit!!");
        }
      });
    },
    objChange(val) {
      // if (val == "3") {
      //   this.initVip();
      //   console.log("objChange", val);
      // }
    },
    checkedGoods(type, index) {
      console.log("选择油品 ", type, index);
      if (type == 0) {
        this.checkedRefule = index;
        this.form.checkedRefule = index; //为了表单验证
        this.form.goods_ids = index.join(",");
        console.log(
          "油品id",
          this.form.goods_ids,
          "sss",
          this.form.checkedRefule
        );
      } else if (type == 1) {
        this.checkedVip = index;
        this.form.level_card_id = index.join(",");
      } else if (type == 4) {
        // 用户标签
        this.selectSign = index;
        this.form.tags_ids = index.join(",");
      }
    },
    //选择优惠券
    getCommod(data) {
      console.log(data);
      let arrCountId = [];
      data.forEach(item => {
        if (item.choseNum) {
          for (var n = 0; n < Number(item.choseNum); n++) {
            arrCountId.push(item.id);
          }
        }
      });
      console.log("子组件传递数据", data, arrCountId);
      if (this.form.give_status == 0) {
        this.onceRule[this.sIndex].sList = data;
        this.onceRule[this.sIndex].coupon_ids = arrCountId.join(",");
      } else {
        this.everyRule[this.sIndex].sList = data;
        this.everyRule[this.sIndex].coupon_ids = arrCountId.join(",");
      }
      this.showSelecter = false;
    },
    //删除选择的优惠券
    delTagItem(i, x) {
      console.log(i, x);
      if (this.form.give_status == 0) {
        this.onceRule[i].sList.splice(x, 1);
        let j = 0;
        let idArr = [];
        for (j in this.onceRule[i].sList) {
          idArr.push(this.onceRule[i].sList[j].id);
        }
        this.onceRule[i].coupon_ids = idArr.join(",");
      } else if (this.form.give_status == 1) {
        this.everyRule[i].sList.splice(x, 1);

        let j = 0;
        let idArr = [];
        for (j in this.everyRule[i].sList) {
          idArr.push(this.everyRule[i].sList[j].id);
        }
        this.everyRule[i].coupon_ids = idArr.join(",");
      }
    },
    selectCoupon(i) {
      this.sIndex = i;
      this.sList = [];
      if (this.form.give_status == 0) {
        this.sList = this.onceRule[i].sList;
      } else if (this.form.give_status == 1) {
        this.sList = this.everyRule[i].sList;
      }
      console.log("选择优惠券", i, this.sList);
      this.showSelecter = true;
    },
    //end
    // 活动类型改变
    // changeStatus(index) {
    //   this.form.give_status = index;
    //   console.log("活动类型", index);
    // },
    // 门店列表
    initStoreType() {
      storeSelect({ token: this.token, app_id: this.app_id }).then(res => {
        if (res.code == 200) {
          if (res.data.length > 0) {
            this.store_options = res.data;
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    initVip() {
      vipList({ token: this.token, app_id: this.app_id }).then(res => {
        console.log("vip", res);
        // this.vipData = res.data;
        // this.$refs.vipChild.goods = res.data;
        if (res.code == 200) {
          this.$refs.vipChild.goods = res.data;
          if (this.checkedVip) {
            this.$refs.vipChild.mallCheckAll =
              this.checkedVip.length < res.data.length ? false : true;
          }
        } else {
          this.$refs.vipChild.mallCheckAll = false;
          this.$refs.vipChild.goods = [];
        }
      });
      var data = {
        token: this.token,
        app_id: this.app_id
      };
      this.$nextTick(function() {
        // // 获取会员卡等级列表
        // vipList(data).then(res => {
        //   if (res.code == 200) {
        //     this.vipLevelList = [];
        //     res.data.forEach(item => {
        //       var i = {
        //         id: String(item.id),
        //         name: item.name
        //       };
        //       this.vipLevelList.push(i);
        //     });
        //   }
        // });
        // 加油卡列表
        listRefule(data).then(res => {
          if (res.code == 200) {
            this.oilsCardList = [];
            res.result.forEach(item => {
              var i = {
                id: String(item.id),
                name: item.name
              };
              this.oilsCardList.push(i);
            });
          }
        });
        // 车队卡列表
        cardList(data).then(res => {
          if (res.code == 200) {
            this.cardListCard = [];
            res.result.forEach(item => {
              var i = {
                id: String(item.id),
                name: item.name
              };
              this.cardListCard.push(i);
            });
          }
        });
        //会员标签列表
        allTag(data).then(res => {
          // if (res.code == 200) {
          //   this.signList = res.data;
          // }
          if (res.code == 200) {
            this.$refs.signChild.goods = res.data;
            if (this.selectSign) {
              this.$refs.signChild.mallCheckAll =
                this.selectSign.length < res.data.length ? false : true;
            }
          } else {
            this.$refs.signChild.mallCheckAll = false;
            this.$refs.signChild.goods = [];
          }
          console.log("标签列表", res);
        });
      });
    },
    //
    details() {
      detailConsumption({
        token: this.token,
        app_id: this.app_id,
        id: this.jude
      }).then(res => {
        console.log("vip", res);
        this.form = res.data;
        // 油品
        var refuleGoods = this.form.goods_ids.split(",");
        this.form.checkedRefule = refuleGoods; //表单验证
        refuleGoods.forEach(item => {
          this.checkedRefule.push(item * 1);
          // return item * 1;
        });
        // 会员卡等级
        var vipGoods = this.form.level_card_id.split(",");
        vipGoods.forEach(item => {
          this.checkedVip.push(item * 1);
        });
        console.log("会员卡等级", this.checkedVip);

        console.log("this.checkedRefule", this.checkedRefule);
        // 部分门店
        if (this.form.room_status) {
          let room = this.form.room_ids.split(",");
          this.roomIdS = [];
          room.forEach(item => {
            this.roomIdS.push(item * 1);
          });
          console.log("this.roomIdS", this.roomIdS);
        }
        this.form.rule.forEach(item => {
          item.moneyStatus = item.money_status ? true : false;
          item.pointStatus = item.point_status ? true : false;
          item.couponStatus = item.coupon_status ? true : false;
          // 优惠券数量
          let couponIds =
            item.coupon_ids != "" ? item.coupon_ids.split(",") : [];
          console.log("item", couponIds);
          item.sList.forEach(item => {
            let dNum = "0";
            couponIds.forEach(son => {
              if (item.id == son) {
                dNum++;
              }
            });
            item.choseNum = dNum;
          });
        });
        // 优惠券选择数量
        // let couponIds = this.form.coupon.split(",");

        // let i = 0;
        // for (i in this.sList) {
        //   let dNum = "0";

        //   for (let d = 0; d < couponIds.length; d++) {
        //     if (this.sList[i].id == couponIds[d]) {
        //       dNum++;
        //     }
        //   }
        //   this.sList[i].choseNum = dNum;
        if (this.form.give_status == 0) {
          this.onceRule = this.form.rule;
        } else {
          this.everyRule = this.form.rule;
        }
        this.form.give_status = String(this.form.give_status);

        // this.activityData = [];
        // this.activityData.push(this.form.start_time);
        // this.activityData.push(this.form.end_time);

        // new 活动时间
        this.dateValue[0] = this.form.start_time.split(" ")[0];
        this.timeValue[0] = this.form.start_time.split(" ")[1];
        this.dateValue[1] = this.form.end_time.split(" ")[0];
        this.timeValue[1] = this.form.end_time.split(" ")[1];

        // string
        this.form.room_status = String(this.form.room_status);
        this.form.use_status = String(this.form.use_status);
        this.form.bus_status = String(this.form.bus_status);
        this.form.take_status = String(this.form.take_status);
        this.form.day_status = String(this.form.day_status);
        // 新
        if (this.form.take_status == "1") {
          let tagArr = this.form.tags_ids.split(",");
          tagArr.map(item => {
            this.selectSign.push(item * 1);
          });
          console.log("selectSign", this.selectSign);
        }

        this.form.take_status = String(this.form.take_status);
        this.shellSelectPay = this.form.payment_code.split(",");
        this.shellSelectPay.map(item => {
          if (item == "balance") {
            this.selectPay.push("branch");
            this.selectPay.push(item);
            this.payStatus = true;
            this.branchPay.push("balance");
          } else if (item == "card_balance") {
            this.selectPay.push("branch");
            this.branchPay.push(item);

            this.branchOil = true;
            this.payStatus = true;
            this.selectOilsCard = this.form.type_card_id.split(",");
          } else if (item == "team_balance") {
            this.selectPay.push("branch");
            this.branchPay.push(item);
            this.branchCard = true;
            this.payStatus = true;
            this.selectCardList = this.form.team_card_id.split(",");
          } else {
            this.selectPay.push(item);
          }
        });
        for (let i = 0; i < this.selectPay.length; i++) {
          for (let j = i + 1; j < this.selectPay.length; j++) {
            if (this.selectPay[i] == this.selectPay[j]) {
              this.selectPay.splice(j, 1);
              j--;
            }
          }
        }
        // end
        console.log("branchPay", this.branchPay);
        console.log("wef", this.selectPay);
      });
    },
    // 增加规则
    addRule() {
      console.log("this.form.rule.length:", this.form.rule.length);
      var data = {
        enough_money: "", //
        money_status: "0", //
        money: "", //
        money_limit: "", //
        point_status: "0", //
        point: "", //
        point_limit: "", //
        coupon_status: "0", //
        coupon_ids: "", //
        sList: [],
        //
        moneyStatus: false,
        pointStatus: false,
        couponStatus: false
      };
      if (this.form.give_status == 0) {
        if (this.onceRule.length == 9) {
          this.$message.warning("您已超出规定的规则数，请勿继续添加！！");
          return;
        }
        this.onceRule.push(data);
      } else {
        if (this.everyRule.length == 9) {
          this.$message.warning("您已超出规定的规则数，请勿继续添加！！");
          return;
        }
        this.everyRule.push(data);
      }
    },
    // 删除规则
    delRule(index) {
      if (this.form.give_status == 0) {
        // 至少保留
        if (this.onceRule.length == 1) {
          this.$message.warning("请至少保留一个条件！！");
          return;
        }
        this.onceRule.splice(index, 1);
      } else {
        // 至少保留
        if (this.everyRule.length == 1) {
          this.$message.warning("请至少保留一个条件！！");
          return;
        }
        this.everyRule.splice(index, 1);
      }
    },
    // 数字 转汉字
    changeH(index) {
      switch (index) {
        case 0:
          return "一";
        case 1:
          return "二";
        case 2:
          return "三";
        case 3:
          return "四";
        case 4:
          return "五";
        case 5:
          return "六";
        case 6:
          return "七";
        case 7:
          return "八";
        case 8:
          return "九";
        case 9:
          return "十";
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 15px;
}
.content1 {
  border: 1px solid #f1f1f1;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  height: 100%;
  // 上层
  .el-form {
    flex: 1;
    padding: 0 20px 10px 20px;
    overflow-y: auto;
    .box {
      background: #f2f2f6;
      margin-top: 20px;
      padding: 10px;
      border-radius: 6px;
      .title {
        font-weight: 550;
        padding: 10px 0px 10px 20px;
      }
      // 样式
      .fontSize14 {
        font-size: 14px;
      }
      .textAlign {
        text-align: right;
      }
      .color {
        margin: 0px 5px;
        color: #999;
        font-size: 12px;
      }
      .inputMargin {
        width: auto;
        margin: 0 6px;
      }
      .inputWidth {
        height: 30px;
        width: 130px;
      }
      .newInputWidth {
        height: 30px;
        width: 120px;
      }
      .fixedButton {
        width: 70px;
      }
      .width30 {
        width: 30px;
        font-size: 14px;
      }
      .marginBottom10 {
        margin-bottom: 20px;
      }
    }
    // 表格
    .table {
      max-width: 900px;
      border: 1px solid #fff;
      background: #fff;
      height: 100%;
      display: flex;
      border-radius: 6px;
      > div {
        padding: 20px;
      }
      .name {
        font-weight: 550;
        padding: none;
      }
      .table-left {
        width: 220px;
        border-right: 1px solid #f1f1f1;
      }
      .table-right {
        flex: 1;
        .marginBottom {
          margin-bottom: 10px;
        }
        margin-bottom: 10px;
      }
    }
  }
  // 底部
  .bottom {
    border-top: 1px solid #f2f2f6;
    height: 60px;
    line-height: 60px;
    background: #fff;
    text-align: center;
    width: 100%;
    padding: 0 20px;
  }

  .flex {
    display: flex;
    align-items: center;
  }
  .fixedWidth {
    width: 500px;
    .line {
      text-align: center;
    }
  }
}
</style>
